export const SET_MAILINGS = 'SET_MAILINGS'
export const ADD_MAILING = 'ADD_MAILING'
export const SET_MAILING = 'SET_MAILING'
export const REPLACE_MAILING = 'REPLACE_MAILING'
export const REMOVE_MAILING = 'REMOVE_MAILING'